import React from 'react'
import { MeshPhysicalMaterial, MeshPhysicalMaterialParameters } from 'three'
import LRUCache from 'lru-cache'

const materialCache = new LRUCache<string, MeshPhysicalMaterial>({ max: 100 })

const useCachedMaterial = (materialProps: MeshPhysicalMaterialParameters) => {
  // TODO: maybe something like
  // https://www.npmjs.com/package/json-stable-stringify would be better to
  // avoid false cache misses
  let material = materialCache.get(JSON.stringify(materialProps))
  if (!material) {
    material = new MeshPhysicalMaterial(materialProps)
    materialCache.set(JSON.stringify(materialProps), material)
  }

  return material
}

export const CachedMeshPhysicalMaterial = React.memo(
  (materialProps: MeshPhysicalMaterialParameters) => {
    const material = useCachedMaterial(materialProps)

    return <primitive key={material.id} object={material} attach="material" />
  }
)
